import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bar } from "react-chartjs-2";
import { bucketTopN, stripPctLabel } from "./_shared/bucketTopN";
import { isValidCutGrade } from "./_shared/isValidCutGrade";
import { ACCENT, barOptions, sliceCursorOnHover } from "./_shared/chartTheme";
import ChartState from "./_shared/ChartState";

const GemstoneReportsCutGradeComp = ({ data, loading, onSliceClick }) => {
  const { t } = useTranslation();
  const [hideNoise, setHideNoise] = useState(true);
  const othersLabel = t("Others");
  const list = data || [];

  const filteredList = useMemo(
    () => (hideNoise ? list.filter((item) => isValidCutGrade(item.CutGrade)) : list),
    [list, hideNoise]
  );
  const hiddenCount = list.length - filteredList.length;

  const { chartData: bucketed } = bucketTopN(filteredList, {
    labelKey: "CutGrade",
    valueKey: "CNT",
    chartLabel: "Cut Grade",
    max: 10,
    othersLabel,
  });
  const rows = bucketed.slice(1);

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        label: t("Count"),
        data: rows.map((row) => row[1]),
        backgroundColor: rows.map((row) =>
          row[0].startsWith(`${othersLabel} (`) ? "#CCCCCC" : ACCENT
        ),
        borderRadius: 4,
      },
    ],
  };

  const handleSliceClick = (_evt, elements) => {
    if (!onSliceClick || !elements?.length) return;
    const row = rows[elements[0].index];
    if (!row) return;
    const label = stripPctLabel(row[0]);
    if (label === othersLabel) return;
    onSliceClick(label);
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Gemstone CutGrade Searches")} </b>
          </label>
          <div className="edr-toggle">
            <span>{t("Hide noise / invalid terms")}</span>
            <label className="edr-switch">
              <input
                type="checkbox"
                checked={hideNoise}
                onChange={(e) => setHideNoise(e.target.checked)}
              />
              <span className="edr-switch-track"></span>
            </label>
            {hiddenCount > 0 && (
              <span className="edr-badge edr-flag">
                {hiddenCount} {t("junk terms hidden")}
              </span>
            )}
          </div>
        </div>
        <div className="chart__section">
          {!loading && rows.length > 0 ? (
            <div className="edr-chartwrap edr-tall">
              <Bar
                data={chartJsData}
                options={{ ...barOptions(true), onClick: handleSliceClick, onHover: sliceCursorOnHover }}
              />
            </div>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default GemstoneReportsCutGradeComp;
